import { useDateFormatter } from "PFCore/hooks/use_date_formatter";
import { useContext, useMemo } from "react";

import AppContext from "../../../app_context";
import { GANTT_MONTHS_LIMIT } from "../overview/calendar/calendar";

interface CalendarGridScope {
  min: string;
  max: string;
}

export const useCalendarGridScope = (): CalendarGridScope => {
  const {
    store: { currentAccount }
  } = useContext(AppContext);
  const { utc, formatDatabaseDateTime } = useDateFormatter();
  const monthsLimit = currentAccount.availability?.calculated_months_limit || GANTT_MONTHS_LIMIT;

  const min = useMemo(
    () => formatDatabaseDateTime(utc().startOf("day").subtract(monthsLimit, "months")),
    [monthsLimit]
  );
  const max = useMemo(
    () => formatDatabaseDateTime(utc().startOf("day").add(monthsLimit, "months")),
    [monthsLimit]
  );

  return {
    min,
    max
  };
};
